import TYPES from '../types';

export default () => {
  return {
    type: TYPES.ENABLE_SWAP,
  };
};
